module.exports = __webpack_public_path__ + "img/weixin.887f5260.png";